import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { commonAction } from "../slices/GameSlice";
import CommonBackground from "../common/CommonBackground";
import { CrossIcon } from "../icon/Icons";

const WordGamePage = () => {
  const dispatch = useDispatch();
  const {
    wordMatchs,
    epilogueMatchs,
    gameMode,
    searchResults,
    searchWord,
    initialConsonant,
  } = useSelector(state => state.GameSlice);

  const [tipDisplay, setTipDisplay] = useState(true);
  const [cellHeight, setCellHeight] = useState(0);
  const containerRef = useRef();
  const listArr = useMemo(
    () => (gameMode === "훈민정음" ? wordMatchs : epilogueMatchs),
    [gameMode, wordMatchs, epilogueMatchs]
  );

  useEffect(() => {
    setTimeout(() => {
      if (containerRef.current) {
        const observer = new ResizeObserver(entries => {
          const container = entries[0];
          setCellHeight(container.contentRect.height / 20);
        });

        observer.observe(containerRef.current);
      }
    }, 0);
  }, [containerRef]);

  const cellStyle = useMemo(
    () => ({ minHeight: cellHeight + "px" }),
    [cellHeight]
  );

  return (
    <Wrap ref={containerRef}>
      <CommonBackground column={20} />

      <InitialBoard style={cellStyle}>{initialConsonant}</InitialBoard>

      <WordArea>
        <DescriptionArea>
          <span>{searchWord} </span>

          {searchResults?.map((item, index) => (
            <DefinitionItem key={`${index}definitionKey`}>
              <OriginItem>
                <span>{item.origin}</span> <span>{item.pos}</span>
                <span>{item.cat}</span>
              </OriginItem>
              <span>{item.definition}</span>
            </DefinitionItem>
          ))}
        </DescriptionArea>
        <WordItemContainer $cellHeight={cellHeight}>
          {[...listArr].reverse().map((item, index) => {
            const handler = () => {
              dispatch(
                commonAction({ target: "searchWord", value: item?.word })
              );
            };
            return (
              <WordItem
                style={cellStyle}
                $current={index === 0}
                onClick={handler}
                key={`${index}wordItemKeys`}>
                <WordText>{item?.word}</WordText>
              </WordItem>
            );
          })}
        </WordItemContainer>
      </WordArea>
      {tipDisplay && (
        <NoticeBar>
          채팅창에 ‘/단어’ 라고 입력하세요.
          <TipClose onClick={() => setTipDisplay(false)}>
            <CrossIcon />
          </TipClose>
        </NoticeBar>
      )}
    </Wrap>
  );
};

export default WordGamePage;

const InitialBoard = styled.div`
  width: 100%;
  height: 21px;
  border: 1px solid #107c41;
  background-color: #fff;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
  position: relative;
`;

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const DescriptionArea = styled.div`
  width: 60%;
  height: 95%;
  padding: 3px 8px;
  display: flex;
  font-size: 12px;
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;

  flex-direction: column;
  position: absolute;
  left: 0;
  bottom: 0;
  align-items: start;
  gap: 20px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const WordArea = styled.div`
  width: 100%;
  height: calc(100% - 21px);
  display: flex;
  position: relative;
  justify-content: end;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const WordItemContainer = styled.div`
  display: flex;
  width: 100%;
  height: ${({ $cellHeight }) => `calc(100% - ${$cellHeight}px)`};
  margin-top: ${({ $cellHeight }) => `${$cellHeight}px`};
  overflow-y: scroll;
  flex-direction: column;
  align-items: end;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const NoticeBar = styled.div`
  width: 100%;
  min-height: 21px;
  color: #242424;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 12px;
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
`;

const WordItem = styled.div`
  display: flex;
  width: 20%;
  min-height: calc(5% + 1px);
  justify-content: center;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  align-items: center;
  cursor: pointer;
  background-color: ${({ $current }) => ($current ? "pink" : "#fff")};
  position: relative;
  &:hover {
    opacity: 0.8;
  }
`;

const DefinitionItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 12px;
`;
const OriginItem = styled.div`
  display: flex;
  gap: 5px;
`;

const WordText = styled.div`
  font-size: 12px;
`;

const TipClose = styled.div`
  position: absolute;
  top: 50%;
  translate: 0 -50%;
  right: 10px;
  cursor: pointer;
`;
